import { Button } from 'antd';
import type { UploadFileOutputDto } from '../features/file/model';

export default function ImageSelector({
  selectedImage,
  onOpenModal,
  required = false,
  text = '图片',
}: {
  selectedImage: UploadFileOutputDto | null;
  onOpenModal: () => void;
  required?: boolean;
  text?: string;
}) {
  return (
    <div className="space-y-3">
      <h3
        className={`text-lg font-semibold text-primary-300 ${required ? 'text-red-400' : ''}`}
      >
        📤 选择{text}
      </h3>
      {selectedImage?.filename ? (
        <div className="rounded-xl border-2 border-primary-200 p-4 text-center">
          <img
            src={selectedImage.file_url}
            alt={text}
            className="mb-3 max-h-[250px] max-w-full rounded-lg object-contain"
          />
          <p className="mb-4 overflow-hidden break-words text-sm text-primary-300">
            {selectedImage.filename}
          </p>
          <Button onClick={onOpenModal} color="primary" variant="solid" block>
            🖼️ 选择{text}
          </Button>
        </div>
      ) : (
        <div className="rounded-xl border-2 border-dashed border-primary-200 p-8 text-center">
          <p className="mb-4 text-primary-500">未选择{text}</p>
          <Button onClick={onOpenModal} color="primary" variant="solid" block>
            🖼️ 选择{text}
          </Button>
        </div>
      )}
    </div>
  );
}
